<template>
  <v-row>
   <v-col cols="12" sm="12" md="12" xs="12" lg="12" xl="12">
    <v-snackbar
          v-model="snackbar"
          bottom
          :timeout="timeout"
          :color="color"
          >
          {{ text }}
    </v-snackbar>
    <v-progress-circular v-if="this.saving"
        indeterminate
        color="green"
      ></v-progress-circular>
      <v-card>
        <v-card-title>
          <span v-if="!showPeriod" class="pb-3 mt-3">
            {{lang.WarehouseState2}},{{$store.state.warehousemarkid}}, {{ lang.FromDate }} {{localDate(startDate)}}, {{ lang.ToDate }} {{localDate(endDate)}}<br />
          </span>
          <v-dialog
            v-model="showPeriod"
            max-width="350px"
          >
            <v-card>
              <v-card-text>
                 <v-row dense>
                  <v-col cols="12" >
                    <span class="headline"> {{lang.WarehouseState2}} {{$store.state.warehousemarkid}} {{lang.WarehouseState3}}</span>
                  </v-col>
                </v-row>
                <v-row dense>
                  <v-col cols="12" >
                    <span class="headline"> {{onTime}}</span>
                  </v-col>
                </v-row>
                 <v-divider class="mt-1"></v-divider>
                <v-row >
                  <v-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12" >
                    {{langC.FromDate}}: <input type="date" ref="docdate"  v-model="startDate" />
                  </v-col>
                </v-row>
                <v-row no-gutters>
                  <v-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12" >
                    {{langC.ToDate}}: <input type="date" v-model="endDate" />
                  </v-col>
                </v-row>
                 <v-row no-gutters>
                  <v-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12" >
                    <v-select
                    :items="privGroups"
                    v-model="selectGroup"
                    :label="lang.selectGroup"
                    single-line
                    item-text="GroupName"
                    item-value="id"
                    return-object
                    persistent-hint
                    clearable
                    dense
                  ></v-select>
                  </v-col>
                </v-row>
                 <v-row no-gutters>
                  <v-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12" >
                    <v-select
                      v-model="selectedMonth"
                      :items="months"
                      label="Mjesec"
                      clearable
                    ></v-select>
                  </v-col>
                </v-row>
                 <v-row no-gutters>
                  <v-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12" >
                    <v-btn
                      color="gray"
                      block
                      @click="selectItems()">
                      {{lang.OnlyZero}}
                    </v-btn>
                  </v-col>
                </v-row>
                <v-row >
                  <v-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12" >
                    <v-btn
                      color="gray" block
                      @click="groupTransactions()">
                      {{lang.GroupsTran}}
                    </v-btn>
                  </v-col>
                </v-row>
                <v-row >
                  <v-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12" >
                    <v-btn
                      color="gray" block
                      @click="groupInOut(1)">
                      {{lang.grIn}}
                    </v-btn>
                  </v-col>
                </v-row>
                <v-row >
                  <v-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12" >
                    <v-btn
                      color="gray" block
                      @click="groupInOut(2)">
                      {{lang.grOut}}
                    </v-btn>
                  </v-col>
                </v-row>
                <v-row >
                  <v-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12" >
                    <v-btn
                      color="gray" block
                      @click="downloadFile()">
                      download
                    </v-btn>
                  </v-col>
                </v-row>
                <v-row >
                  <v-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12" > 
                    <v-btn
                      color="gray" block
                      @click="printAna()">
                      {{langC.Print}}
                    </v-btn>
                  </v-col>
                </v-row>
                <v-row >
                  <v-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12" > 
                    <v-btn
                      color="gray" block
                      @click="confirmTransfer()">
                      Prebaci u ->{{ (this.$store.state.businessYear + 1) }}
                    </v-btn>
                  </v-col>
                </v-row>

                 <v-divider class="mt-3 mb-3"></v-divider>
                <v-row>
                  <v-col cols="12" >
                    <v-btn color="green" block @click="refreshPeriod()">Refresh</v-btn>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12" >
                    <v-btn color="primary" block @click="switchPeriod()">Zatvori</v-btn>
                  </v-col>
                </v-row>
              </v-card-text>
              <v-card-actions>
                
              </v-card-actions>
            </v-card>
          </v-dialog>
 
          
          <v-row no-gutters v-if="!showPeriod">

            <v-col cols="12" sm="1" md="1" xs="1" lg="1" xl="1"  >

            </v-col>
              
              <v-col cols="12" sm="2" md="1" xs="1" lg="1" xl="1"  >

              </v-col>
                <v-col cols="12" sm="1" md="1" xs="1" lg="1" xl="1"  >

              </v-col>
              <v-col cols="12" sm="2" md="2" xs="2" lg="2" xl="2"  >
                <v-text-field
                  append-icon="mdi-magnify"
                  label="Search"
                  single-line
                  hide-details
                  v-model="search"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="1" md="1" xs="1" lg="1" xl="1"  >

              </v-col>
            <v-col cols="12" sm="1" md="1" xs="1" lg="1" xl="1"  >
              <v-btn
                color="primary"
                @click="switchPeriod()">
                Opcije
              </v-btn>
            </v-col>
          </v-row>
        </v-card-title>

        <v-data-table
            dense
            :headers="headers"
            :items="items"
            item-key="id"
            :search="search"
            :footer-props="{
              'items-per-page-options': [10, 20, 30, 40, 50]
            }"
            :items-per-page="50"
            @click:row="navigateTo"
          >
          <template v-slot:[`item.ItemSuppDate`]="{ item }">
              <span>{{ localDate(item.ItemSuppDate) }}</span>
          </template>
          <template v-slot:[`item.itemPrice`]="{ item }">
              <span>{{ localMoney(item.itemPrice) }}</span>
          </template>
          <template v-slot:[`item.itemPriceWithVAT`]="{ item }">
              <span>{{ localMoney(item.itemPriceWithVAT) }}</span>
          </template>
          <template v-slot:[`item.TotalPlus`]="{ item }">
            <span>{{ localMoney(item.TotalPlus) }}</span>
          </template>
          <template v-slot:[`item.TotalMinus`]="{ item }">
              <span>{{ localMoney(item.TotalMinus) }}</span>
          </template>
          <template v-slot:[`item.TotalPcs`]="{ item }">
              <span>{{ localMoney(item.TotalPcs) }}</span>
          </template>
          <template slot="pageText" slot-scope="{ pageStart, pageStop }">
            From {{ pageStart }} to {{ pageStop }}
          </template>
          <template v-slot:no-data>
            {{ lang.noDataList }}
          </template>
        </v-data-table>
      </v-card>
      <v-row>
      <v-col cols="12" sm="10" md="10" xs="10" lg="10" xl="10">
        <DocumentWarehousestatePrint ref="prnt"/>
      </v-col>
      <v-col cols="12" sm="10" md="10" xs="10" lg="10" xl="10">
        <DocumentWarehouseGroupsPrint ref="prnt2"/>
      </v-col>
      <v-col cols="12" sm="10" md="10" xs="10" lg="10" xl="10">
        <DocumentWarehouseGroupsInOutPrint ref="prnt3"/>
      </v-col>
    </v-row>
     <v-row v-if="showCard">
      <v-col cols="12" sm="12" md="12" xs="12" lg="12" xl="12">
        <DocumentItemCard :itemCard="itemCard" :newCardItems="newCardItems" :key="refreshCard"/>
      </v-col>
    </v-row>
  </v-col>
 </v-row>
</template>

<script>
// import axios from 'axios'
import DocumentService from '@/services/DocumentService'
import langEn from './documentDescEn'
import langHr from './documentDescHR'
import commEn from '@/language/commonEN'
import commHr from '@/language/commonHR'
import dateFormat from '@/snippets/dateFormat'
import moneyFormat from '@/snippets/moneyFormat'
import DocumentWarehousestatePrint from './DocumentWarehouseStatePrint'
import DocumentWarehouseGroupsPrint from './DocumentWarehouseGroupsPrint'
import DocumentWarehouseGroupsInOutPrint from './DocumentWarehouseGroupsInOutPrint'
import DocumentItemCard from './DocumentItemCard'
import DocumentDetailService from '@/services/DocumentDetailService'
import { round } from '@/snippets/allSnippets'
import { defDocument, defDocumentDetail, defNewDocumentDetail } from './documentHelper'
import xlsx from 'json-as-xlsx'
import dayjs from 'dayjs'

export default {
  name: 'documentwarehousestate',
  props: ['fromDate', 'toDate'],
  data () {    
    return {
      items: [],
      itemsLoc: [],
      itemsWH: [],
      documentName: '',
      documentNameLoc: '',
      msg: '',
      tmp: '',
      search: '',
      pagination: {},
      rowsPerPageItems: [50],
      headers: [ ],
      mainQuery: {},
      columns: [],
      rows: [],
      lang: {},
      langC: {},
      saving: false,
      documentAna: {},
      document: {},
      savedDocument: {},
      ana: {},
      privGroups: [],
      selectGroup: {},
      haveGroupId: null,
      showCard: false,
      refreshCard: 0,
      disableGroup: false,
      onTime: '',
      showPeriod: false,
      months: [1,2,3,4,5,6,7,8,9,10,11,12],
      selectedMonth: null,
      startDate: null,
      endDate: null,
      dialog1: false,
      dialog2: false,
      modal1: false,
      modal2: false,
      all: {},
      grTotalIn: 0,
      grTotalOut: 0,
      grTotalSum: 0,
      groups: [],
      groupin: [],
      groupout: [],
      docDetailItems: [],
      snackbar: false,
      text: '',
      color: '',
      timeout: 2000,
      newCardItems: null,
      itemCard: null,
      totalPcs: 0,
      totalSupp:0,
      totalMargin:0,
      totalNetto:0,
      totalVAT:0,
      totalTotal:0
    }
  },
  mounted () {
    this.itemsLoc = this.$store.state.itemStore ? this.$store.state.itemStore : []
    // do analysis from database
    if (this.$store.state.language === 'EN') {
      this.lang = langEn
      this.langC = commEn
    }
    if (this.$store.state.language === 'HR') {
      this.lang = langHr
      this.langC = commHr
    }
    this.onTime = dayjs([this.$store.state.businessYear]).startOf('year').format('DD.MM.YYYY') + '-' + dayjs(new Date()).format('DD.MM.YYYY') + ', ' + dayjs(new Date()).format('HH:mm:ss')
    //this.items = this.$store.state.warehouseState ? this.$store.state.warehouseState : []
    this.headers.push(
      {text: this.lang.ItemID, value: 'itemID', width: '90px'},
      {text: this.lang.ItemName, value: 'itemName', width: '250px'},
      {text: this.lang.ItemPcsPlus, value: 'TotalPlus', align: 'right', type: 'decimal', width: '100px'},
      {text: this.lang.ItemPcsMinus, value: 'TotalMinus', align: 'right', type: 'decimal', width: '100px'},
      {text: this.lang.itemState, value: 'TotalPcs', align: 'right', type: 'decimal', width: '100px'},
      {text: this.lang.ItemPrice, value: 'itemPrice', align: 'right', width: '90px'},
      {text: this.lang.ItemPriceWithVAT, value: 'itemPriceWithVAT', align: 'right', width: '90px'},
      {text: this.lang.GroupName, value: 'GroupName', width: '250px'},
      {text: this.lang.Supplier, value: 'ItemSuppCode', width: '250px'},
      {text: this.lang.id, value: 'id', width: '50px'}
    )
    this.privGroups = this.$store.state.groupStore ? this.$store.state.groupStore : []
    this.$store.dispatch("setGroupid", null)
    if (this.selectGroup && this.selectGroup.id) {
      this.$store.dispatch("setGroupid", this.selectGroup.id)
    }
    if (this.$store.state.companyid) {
      this.documentAna.CompanyId = this.$store.state.companyid
    }
    if (this.$store.state.businessYear) {
      this.documentAna.BusinessYear = this.$store.state.businessYear
    }
    const fDate = dayjs([this.documentAna.BusinessYear]).startOf('year').format('YYYY-MM-DD')
    const tDate = dayjs([this.documentAna.BusinessYear]).endOf('year').format('YYYY-MM-DD')
  
    this.documentAna.WareHouseId = this.$store.state.warehousemarkid ? this.$store.state.warehousemarkid : 1

    this.startDate = this.fromDate ? this.fromDate : fDate
    this.endDate = this.toDate ? this.toDate : tDate

    this.documentAna.docFromDate = this.fromDate ? this.fromDate : fDate
    this.documentAna.docToDate = this.toDate ? this.toDate : tDate

    this.initData(1)
  },
  methods: {
    switchPeriod() {
      this.showPeriod = !this.showPeriod
    },
    refreshPeriod(){
      this.showPeriod = false
      if (this.startDate) {
        this.documentAna.docFromDate = this.startDate
      }
      if (this.endDate) {
        this.documentAna.docToDate = this.endDate
      }
      this.showCard = false
      this.selectGroup = null
      this.$store.dispatch("setGroupid", null)
      this.initData(1)
    },
    async initData(type) {
      try {
        this.localError = false
        this.error = null
        this.Total1 = 0
        this.Total2 = 0
        this.Total3 = 0
        this.Total4 = 0
        this.Total5 = 0
        this.Total6 = 0
        this.Total7 = 0
        this.Total8 = 0
        this.Total9 = 0
        this.Total10 = 0
        this.Total21 = 0
        this.Total31 = 0
        
        this.haveGroupId = null
        
        if (this.$store.state.groupid && this.itemsWH) {
         //this.documentAna.groupid = this.$store.state.groupid
          this.items = this.itemsWH.filter(item => item.GroupId === this.$store.state.groupid.toString())
          this.haveGroupId = this.$store.state.groupid
          return
        }
        if (this.disableGroup && this.itemsWH) {
          this.items = [...this.itemsWH]
          this.disableGroup = false
          return
        }
        this.items.splice(0, this.items.length)
        this.itemsWH.splice(0, this.itemsWH.length)
        this.groupin.length = 0
        this.groupout.length = 0

        this.onTime = this.localDate(this.documentAna.docFromDate) + '-' + this.localDate(this.documentAna.docToDate)

        //console.log('this.documentAna', this.documentAna)

        this.saving = true
        const res = (await DocumentService.documentwarehousestate(this.documentAna)).data
        const tempItems = res.document? res.document : []
        this.groupin = res.whgroupin ? res.whgroupin[0] : []
        this.groupout = res.whgroupout ? res.whgroupout[0] : []
        let iid = 0
        const lenItems = this.itemsLoc.length

        if (tempItems[0]) {
          tempItems[0].map(async(item) => {
            const newEntry = {}
            newEntry.itemID = item.itemID ? item.itemID.trim() : ''
            //const findIt = this.itemsLoc.find( itemL => itemL.itemID.trim() === item.itemID)
            let findIt = {}
            
            for(let i = 0; i < lenItems; i++) {
               
              if(this.itemsLoc[i].itemID === item.itemID){
                findIt = this.itemsLoc[i]
                break
              }
            }
            // umjesto find, treba probati sa foor loop jer je strasno brz, evo primjer

            // const numbers = ['one', 'two', 'three', 'five', 'eight', 'thirteen']

            // let item

            // for (let i = 0; i < numbers.length; i++) {
            //   if (numbers[i] === 'five') {
            //     item = numbers[i]
            //     break
            //   }
            // }

            // console.log(item) // 'five'

            newEntry.itemName = findIt.itemName ? findIt.itemName : ''
            newEntry.GroupName = findIt.GroupName ? findIt.GroupName : ''
            newEntry.GroupId = findIt.GroupId ? findIt.GroupId.toString() : ''
            const itemPrice = findIt.itemPrice ? parseFloat(findIt.itemPrice) : 0
            const itemPriceWithVAT = findIt.itemPriceWithVAT ? parseFloat(findIt.itemPriceWithVAT) : 0
            newEntry.itemVAT1Percentage = findIt.itemVAT1Percentage ? parseFloat(findIt.itemVAT1Percentage) : ''
            newEntry.itemPrice = itemPrice
            newEntry.itemPriceWithVAT = itemPriceWithVAT
            newEntry.ItemSuppCode = findIt.ItemSuppCode ? findIt.ItemSuppCode : ''
            newEntry.TotalPlus = parseFloat(item.TotalPlus ? item.TotalPlus : 0)
            newEntry.TotalMinus = parseFloat(item.TotalMinus ? item.TotalMinus : 0)
            const statePcs = parseFloat(item.TotalPlus ? item.TotalPlus : 0) - parseFloat(item.TotalMinus ? item.TotalMinus : 0)
            newEntry.TotalPcs = statePcs
            newEntry.TotalBase = round((itemPrice * statePcs), 2)
            newEntry.TotalWithVAT = round((itemPriceWithVAT * statePcs), 2)
            let saveItem = true
            // if have group id filter
            if (this.haveGroupId) {
              saveItem = false
              if (this.haveGroupId === findIt.GroupId) {
                saveItem = true
              }
            }
            if (findIt.itemService === true) {
              saveItem = false
            }
            if (saveItem) {
              if (type === 1) {
                if (newEntry.TotalPcs !== 0) {
                  this.Total1 += parseFloat(item.TotalPlus ? item.TotalPlus : 0)
                  this.Total2 += parseFloat(item.TotalMinus ? item.TotalMinus : 0)
                  iid += 1
                  newEntry.id = iid
                  this.itemsWH.push(newEntry)
                }
              }
              if (type === 2) {
                if (newEntry.TotalPcs === 0) {
                  this.Total1 += parseFloat(item.TotalPlus ? item.TotalPlus : 0)
                  this.Total2 += parseFloat(item.TotalMinus ? item.TotalMinus : 0)
                  iid += 1
                  newEntry.id = iid
                  this.itemsWH.push(newEntry)
                }
              }            
            }
          })


        }
        this.typeAna = 4
        this.items= [...this.itemsWH]
        this.saving = false
      } catch(err) {
        this.error = 'Greska u konekciji na bazu' + err
      }
    },
    selectItems() {
      this.initData(2)
    },
    localMoney(moneyToFormat) {
      return moneyFormat(moneyToFormat)
    },
    localDate(dateToFormat) {
      return dateFormat(dateToFormat)
    },
    async groupInOut(type) {
      if (!this.documentAna.groupid ) {
        alert('Grupa NIJE odabrana!!!')
        return
      }
      if (this.startDate) {
        this.documentAna.docFromDate = this.startDate
      }
      if (this.endDate) {
        this.documentAna.docToDate = this.endDate
      }
      console.log('>>>>this.documentAna', this.documentAna)
      this.documentAna.documentSide = type
      const res = await DocumentDetailService.salesana(this.documentAna)
      const src = res.data.document ? res.data.document : []
      if (src.length > 0) {
        const newObj = {}
        this.ana = {...newObj}
        this.ana = {...this.documentAna}
        this.ana.docFromDate =  this.localDate(this.documentAna.docFromDate)
        this.ana.docToDate =  this.localDate(this.documentAna.docToDate)
        this.ana.head1 =  type === 1 ? 'Ulaz za grupu' : 'Izlaz za grupu'
        this.ana.head2 =  this.documentAna.GroupName
        this.ana.GroupName = this.documentAna.GroupName
        this.ana.documentSide = type
        this.ana.items = src ? src : []
        this.$store.dispatch('setPrintObj', this.ana)
        this.$refs.prnt3.print()
      }

    },
    groupTransactions() {
      let nr =0
      const emAr = []
      this.groups = [...emAr]
      const res = Array.from(this.itemsWH.reduce(
          (m, {GroupId, TotalPcs}) => m.set(GroupId, (m.get(GroupId) || 0) + (TotalPcs,2)), new Map
        ), ([GroupId, TotalPcs]) => ({GroupId, TotalPcs}));
      if (res && res.length > 0) {
        res.map(gr => {
          this.grTotalIn = 0
          this.grTotalOut = 0
          this.grTotalSum = 0
          let grTotalInM = 0
          let grTotalOutM = 0
          let GroupName = ''
          const onlyGr = this.itemsWH.filter(group => group.GroupId === gr.GroupId)
          if (onlyGr && onlyGr.length > 0) {
            GroupName = onlyGr[0].GroupName ? onlyGr[0].GroupName : 0
            onlyGr.map(oneGr => {
              this.grTotalIn += oneGr.TotalPlus
              this.grTotalOut += oneGr.TotalMinus
            })
          }
  
          const onlyGrIn = this.groupin.filter(grin => grin.itemGroup === gr.GroupId)
          if (onlyGrIn && onlyGrIn.length > 0) {
            grTotalInM = round(( onlyGrIn[0].TotalMPlus), 2)
          }
          const onlyGrOut = this.groupout.filter(grout => grout.itemGroup === gr.GroupId)
          if (onlyGrOut && onlyGrOut.length > 0) {
              grTotalOutM = round(( onlyGrOut[0].TotalMMinus), 2)
          }
          nr += 1
          const newGr = {}
          newGr.id = nr
          newGr.GroupId = gr.GroupId
          newGr.GroupName = GroupName
          newGr.grTotalIn = round(this.grTotalIn,3)
          newGr.grTotalOut = round(this.grTotalOut,3)
          newGr.grTotalSum = round(this.grTotalIn - this.grTotalOut,3)
          newGr.grTotalInM = round(grTotalInM,2)
          newGr.grTotalOutM = round(grTotalOutM, 2)
          newGr.grTotalSumM = round(grTotalInM - grTotalOutM,2)
          this.groups.push(newGr)

        })
      }
      const newObj = {}
      this.ana = {...newObj}
      this.ana = {...this.documentAna}
      this.ana.docFromDate =  this.localDate(this.documentAna.docFromDate)
      this.ana.docToDate =  this.localDate(this.documentAna.docToDate)
      this.ana.documentName = 'Promet skladišta po grupama'
      this.ana.items = this.groups ? this.groups : []
      this.$store.dispatch('setPrintObj', this.ana)
      this.$refs.prnt2.print()
    },
    async navigateTo (params) {
      this.refreshCard += 1
      console.log('params', params)
      if (params && confirm('Želite li karticu artikla: ' + params.itemName + ', ' + params.itemID + ' ?')) {
        this.$store.dispatch('setSelectedItemId', null)
        this.$store.dispatch('setDocumentAna', null)
        this.showCard = false
        this.$store.dispatch('setSelectedItemId', params.itemID)
        this.itemCard = params
        const haveItem = {}
        if (this.$store.state.companyid) {
          haveItem.CompanyId = this.$store.state.companyid
        }
        if (this.$store.state.businessYear) {
          haveItem.BusinessYear = this.$store.state.businessYear
        }
        if (params.itemID) {
          haveItem.itemID = params.itemID
        }
        this.itemCard.WareHouseId = this.$store.state.warehousemarkid  ? this.$store.state.warehousemarkid  : 1
        // haveItem.docFromDate = dayjs([haveItem.BusinessYear]).startOf('year').format('YYYY-MM-DD')
        // haveItem.docToDate = dayjs([haveItem.BusinessYear]).endOf('year').format('YYYY-MM-DD')
        this.itemCard.docFromDate = dayjs(this.startDate).format('YYYY-MM-DD')
        this.itemCard.docToDate = dayjs(this.endDate).format('YYYY-MM-DD')
        const query = {}
        query.CompanyId = this.$store.state.companyid? this.$store.state.companyid: 0
        query.BusinessYear = this.$store.state.businessYear  ? this.$store.state.businessYear  : 2020
        query.WareHouseId = this.$store.state.warehousemarkid  ? this.$store.state.warehousemarkid  : 1
        query.itemID = params.itemID ? params.itemID : ''
        query.docFromDate = this.startDate ? dayjs(this.startDate).format('YYYY-MM-DD'): dayjs([this.$store.state.businessYear]).startOf('year').format('YYYY-MM-DD')
        query.docToDate = this.endDate ? dayjs(this.endDate).format('YYYY-MM-DD'): dayjs([this.$store.state.businessYear]).endOf('year').format('YYYY-MM-DD')
        this.saving = true
        if (this.newCardItems && this.newCardItems.length > 0){
          this.newCardItems.length = 0}
        try {
           const document = (await DocumentService.documentitemcard(query)).data.document
           if (document && document.length > 0) {
            this.newCardItems = document[0]
           }
           console.log('document', document)
           console.log('newCardItems', this.newCardItems.length)

           this.saving = false
           this.$store.dispatch('setDocumentAna', haveItem)
           this.showCard = true
           console.log('prikazem karticu')
        } catch (error) {
          this.saving = false
          alert('Error to retrieve car. Greska u dohvatu podataka kartice!')
          this.$store.dispatch('setSelectedItemId', null)
          this.$store.dispatch('setDocumentAna', null)
          this.showCard = false
        }
        

      } else {
        this.$store.dispatch('setSelectedItemId', null)
        this.$store.dispatch('setDocumentAna', null)
        this.showCard = false
      }
    },
    async printAna() {
      const newObj = {}
      this.ana = {...newObj}
      this.ana = {...this.documentAna}
      this.ana.docFromDate =  this.localDate(this.documentAna.docFromDate)
      this.ana.docToDate =  this.localDate(this.documentAna.docToDate)
      if (this.selectGroup && this.selectGroup.GroupName) {
        this.ana.GroupName = this.selectGroup.GroupName
      }

      this.ana.items = this.items ? this.items : []
      await this.$store.dispatch('setPrintObj', this.ana)
      await this.$refs.prnt.print()
    },
    downloadFile () {
        const currDate = dayjs().format('DD_MM_YYYY_HH_MM')  
        const sheetNm = 'StanjeSkl' + '_' + currDate
        let data = [
        {
          sheet: sheetNm,
          columns: [
            { label: 'Šifra', value: 'itemID' },
            { label: 'Naziv', value: 'itemName' },
            { label: 'Količina zaduži', value: 'TotalPlus' },
            { label: 'Količina razduži', value: 'TotalMinus' },
            { label: 'Stanje skladišta', value: 'TotalPcs' },
            { label: 'Cijena', value: 'itemPrice' },
            { label: 'Cijena sa PDVom', value: 'itemPriceWithVAT' },
            { label: 'Ulaz na skladište', value: 'ItemSuppCode' },
            { label: 'Stanje', value: 'TotalBase' },
            { label: 'Stanje sa PDVom', value: 'TotalWithVAT' },
            { label: 'Grupa', value: 'GroupName' },
          ],
          content: this.items
        }
      ]
          
      let settings = {
          fileName: 'StanjeSkladista_' + currDate,
          extraLength: 3, // A bigger number means that columns will be wider
          writeOptions: {} // Style options from https://github.com/SheetJS/sheetjs#writing-options
        }
      // const settings = {
      //   sheetName: 'StanjeSkladista',
      //   fileName: 'StanjeSkladista_' + currDate
      // }
      xlsx(data, settings)
    },
    getRndInteger(min, max) {
      return Math.floor(Math.random() * (max - min) ) + min;
    },
    async confirmTransfer () {
      if (confirm('Da li ste sigurni da želite prebaciti stanje skladišta u inventuru ' +  (this.$store.state.businessYear + 1) + ' godine ? (Are you shure to transfer warehouse state to inventory in ' +  (this.$store.state.businessYear + 1) + ' year?)')) {
        await this.createNewDocument()
        await this.saveDetItems()
        await this.makeSum()
        this.switchPeriod()
        this.text = 'Inventura je spremljena. Inventory is saved.'
        this.color = 'green'
        this.snackbar = true
        this.timeout = 2000
      }
    },
    async createNewDocument() {
      this.document = defDocument()
      if (this.$store.state.companyid) {
        this.CompanyId = this.$store.state.companyid
        this.mainQuery.CompanyId = this.$store.state.companyid
      }
      const inNewYear = parseInt(this.$store.state.businessYear) + 1

      this.document.UserId = this.$store.state.user.id ? this.$store.state.user.id : ''
      this.document.email = this.$store.state.user.email ? this.$store.state.user.email : 'test@cegrupa.com'
      this.document.First = this.$store.state.user.First ? this.$store.state.user.First : 'NoFirst'
      this.document.Last = this.$store.state.user.Last ? this.$store.state.user.Last : 'NoLast'
      this.document.CompanyId = this.$store.state.companyid ? this.$store.state.companyid : 0
      this.mainQuery.CompanyId = this.$store.state.companyid ? this.$store.state.companyid : 0
      this.document.CompanyNameDatabase = this.$store.state.companyName ? this.$store.state.companyName : ''
      this.document.BusinessYear = inNewYear
      this.mainQuery.BusinessYear = inNewYear
      this.mainQuery.documentName = 'Inventory'
      this.document.documentName = 'Inventory'
      this.document.documentAnalysis = 1
      this.document.documentSide = 1
      this.mainQuery.WareHouseId = this.$store.state.warehousemarkid ? this.$store.state.warehousemarkid : 1

      const startDate = dayjs([inNewYear]).startOf('year').format('YYYY-MM-DD')
    
      this.document.documentDate = startDate
      this.document.documentTime = dayjs(new Date()).format('HH:mm')
      this.document.documentInvoiceStartDate = startDate
      this.document.documentInvoiceEndDate = startDate
      this.document.documentHomeCurrency = this.$store.state.businessYear <= 2022 ? 'Kn' : 'EUR'
      this.document.documentForeignCurrency = 'EUR'
      this.document.documentExRate = this.$store.state.businessYear <= 2022 ? 7.5345 : 1

      this.document.documentId = parseInt((await DocumentService.choose(this.mainQuery)).data.docNumber)
      if (this.document.documentId && this.document.documentId > 0)
      {
        this.document.documentIdGeneral = this.$store.state.companyName + '-' + inNewYear + '-' + 'Inventory' + '-' + this.document.documentId + '-' + (this.$store.state.warehousemarkid ? this.$store.state.warehousemarkid : 1)
        this.document.WareHouseId = (this.$store.state.warehousemarkid ? this.$store.state.warehousemarkid : 1)
        const whObj =  this.$store.state.warehouseState ? this.$store.state.warehouseState.find(whID => whID.WareHouseId === this.$store.state.warehousemarkid) : []
        this.document.WareHouseName = whObj && whObj.WareHouseName ? whObj.WareHouseName : ''
        await DocumentService.post(this.document)
          .then(response => {
            
            const newDoc = response.data && response.data.newDoc ? response.data.newDoc : null
            if (newDoc) {
              this.savedDocument = {...newDoc}
              this.items.map(itm => {
                const pcsLoc = itm.TotalPcs ? itm.TotalPcs : 0
                let documentDet = defDocumentDetail()

                documentDet.databaseDocID = newDoc.id
                documentDet.CompanyId = newDoc.CompanyId
                documentDet.CompanyNameDatabase = newDoc.CompanyNameDatabase
                documentDet.BusinessYear = newDoc.BusinessYear
                documentDet.UserId = newDoc.UserId
                documentDet.email = newDoc.email ? newDoc.email : 'email@email.com'
                documentDet.documentName = newDoc.documentName
                documentDet.documentId = parseInt(newDoc.documentId)
                documentDet.documentIdGeneral = newDoc.documentIdGeneral
                documentDet.documentDate = newDoc.documentDate
                documentDet.partnerId = newDoc.partnerId
                documentDet.partnerNameDatabase = newDoc.partnerNameDatabase
                documentDet.HomeCurrency = newDoc.documentHomeCurrency
                documentDet.ForeignCurrency = newDoc.documentForeignCurrency
                documentDet.ExRate = 1
                documentDet.ItemHomeCurrency = newDoc.documentHomeCurrency
                documentDet.ItemForeignCurrency = newDoc.documentForeignCurrency
                documentDet.documentSide = 1
                documentDet.documentAnalysis = 2

                documentDet.itemID = itm.itemID
                documentDet.itemName = itm.itemName
                documentDet.itemGroup = itm.GroupId
                documentDet.itemGroupName = itm.GroupName ? itm.GroupName : ''
                const docItem = this.$store.state.itemStore ? this.$store.state.itemStore.find(item => item.itemID === itm.itemID) : []
                documentDet.itemUnit = docItem && docItem.itemUnit ? docItem.itemUnit : ''
                documentDet.itemMargin = 0
                documentDet.itemMarginAmount = 0
                documentDet.itemMaxDiscount = 0
                documentDet.itemSuppBasePrice = docItem && docItem.itemPrice ? round(docItem.itemPrice, 3) : round(itm.itemPrice, 3)
                documentDet.itemSuppPrice = docItem && docItem.itemPrice ? round(docItem.itemPrice, 3) : round(itm.itemPrice, 3)
                documentDet.itemPrice = itm.itemPrice ? round(itm.itemPrice, 3) : 0
                documentDet.itemVAT1Percentage = itm.itemVAT1Percentage ? round(itm.itemVAT1Percentage, 2) : 0
                documentDet.itemPriceWithVAT = itm.itemPriceWithVAT ? round(itm.itemPriceWithVAT, 2) : 0
                documentDet.itemPcsPlus = pcsLoc

                documentDet.itemDiscountPercentage1 = 0
                documentDet.itemDirectDuty1 = 0

                documentDet.itemAmountWithVAT = itm.TotalWithVAT
                documentDet.itemDirectDuty1Amount = 0
                documentDet.itemFullTotal = itm.TotalWithVAT
                documentDet.itemFullTotal = round(documentDet.itemFullTotal, 2)

                documentDet.itemBaseAmountNoVAT= documentDet.itemAmountWithVAT / (1 + (documentDet.itemVAT1Percentage / 100))
                documentDet.itemBaseAmountNoVAT = round((documentDet.itemBaseAmountNoVAT), 2)
                documentDet.itemSuppPriceAmount = round((documentDet.itemBaseAmountNoVAT), 2)
                documentDet.itemBaseAmount = round((documentDet.itemBaseAmountNoVAT), 2)
                documentDet.itemMarginAmount = (documentDet.itemBaseAmount - documentDet.itemSuppPriceAmount) ? this.round((documentDet.itemBaseAmount - documentDet.itemSuppPriceAmount),2) : 0
                documentDet.itemMargin = 0
                if (documentDet.itemSuppPriceAmount !== 0) {
                  documentDet.itemMargin = (documentDet.itemMarginAmount / (documentDet.itemSuppPriceAmount / 100)) ? this.round((documentDet.itemMarginAmount / (documentDet.itemSuppPriceAmount / 100)),2) : 0
                }
                documentDet.FreeF2 = (documentDet.itemMarginAmount / pcsLoc) ? this.round((documentDet.itemMarginAmount / pcsLoc),2) : 0

                
                this.docDetailItems.push(documentDet)

              })
              console.log('this.docDetailItems', this.docDetailItems)
            }
          })
          .catch(err => {
            // eslint-disable-next-line
            console.log(err)
            this.text = 'Error post!' + err
            this.color = 'red'
            this.snackbar = true
            this.timeout = 4000
          })
      }

    },
    async saveDetItems() {
      await DocumentDetailService.saveitems(this.docDetailItems)
    },
    async makeSum() {
      const updateSumObject = {
        documentDescription9: 0,
        documentDescription10: 0,
        documentTotalVAT1Per: 0,
        documentTotalVAT1Base: 0,
        documentTotalVAT1Amount: 0,
        documentTotalVAT2Per: 0,
        documentTotalVAT2Base: 0,
        documentTotalVAT2Amount: 0,
        documentTotalVAT3Per: 0,
        documentTotalVAT3Base: 0,
        documentTotalVAT3Amount: 0,
        documentTotalVAT4Per: 0,
        documentTotalVAT4Base: 0,
        documentTotalVAT4Amount: 0,
        documentTotalVAT5Per: 0,
        documentTotalVAT5Base: 0,
        documentTotalVAT5Amount: 0,
        documentTotalAmountNetto: 0,
        documentTotalAmountVAT: 0,
        documentTotalAmountBrutto: 0,
        documentTotalAmountPayInAdvance: this.$store.state.documentActivHead.documentTotalAmountPayInAdvance ? parseFloat(this.$store.state.documentActivHead.documentTotalAmountPayInAdvance) : 0,
        documentTotalAmountToPay: 0,
        documentTotalAmountNettoForeign: 0,
        documentTotalAmountVATForeign: 0,
        documentTotalAmountBruttoForeign: 0,
        documentTotalAmountPayInAdvanceForeign: 0,
        documentTotalAmountToPayForeign: 0,
        documentTotalAmountDirectD1: 0,
        documentTotalAmountDirectD2: 0,
        documentTotalAmountDirectD1Fore: 0,
        documentTotalAmountDirectD2Fore: 0,
        supplierAmount: 0,
        supplierNetoAmount: 0,
        supplierDiscount: 0,
        supplierMargin: 0,
        FreeF1: 0,
        FreeF2: 0,
        FreeF3: 0,
        FreeF4: 0,
        FreeF5: 0,
        FreeF6: 0,
      }
      let dSide = 3
      if (this.$store.state.documentSide) {
        dSide = this.$store.state.documentSide
      }

      const hrVat1 = 25
      const hrVat2 = 13
      const hrVat3 = 5
      const documentsDet = this.docDetailItems
      if (documentsDet) {
        documentsDet.map(documentDet => {

          let pcsLoc = 0
          if (dSide === 1 ) {
            pcsLoc = parseFloat(documentDet.itemPcsPlus) ? parseFloat(documentDet.itemPcsPlus)  : 0
          }
          if (dSide === 2 ) {
            pcsLoc = parseFloat(documentDet.itemPcsMinus) ? parseFloat(documentDet.itemPcsMinus)  : 0
          }
          if (dSide === 3 ) {
            pcsLoc = parseFloat(documentDet.itemPcsNeutral) ? parseFloat(documentDet.itemPcsNeutral)  : 0
          }
          pcsLoc = round(pcsLoc, 3)     
          
          if ((documentDet.itemSuppBasePriceAmount)) {
            updateSumObject.supplierAmount += round((documentDet.itemSuppBasePriceAmount),2)
          }
          if (documentDet.itemSuppDiscountAmount) {
            updateSumObject.supplierDiscount += round(documentDet.itemSuppDiscountAmount,2)
          }
          if (documentDet.itemSuppPriceAmount) {
            updateSumObject.supplierNetoAmount += round(documentDet.itemSuppPriceAmount,2)
          }
          if (documentDet.itemBaseAmount) {
            updateSumObject.documentDescription9 += parseFloat(documentDet.itemBaseAmount)
          }
          if (documentDet.itemBaseAmountNoVAT) {
            updateSumObject.documentTotalAmountNetto += parseFloat(documentDet.itemBaseAmountNoVAT)
          }
          // if (documentDet.itemVAT1Amount) {
          //   updateSumObject.documentTotalAmountVAT += parseFloat(documentDet.itemVAT1Amount)
          // }
          //const dD1 = documentDet.itemDirectDuty1Amount ? parseFloat(documentDet.itemDirectDuty1Amount) : 0
          // if (documentDet.itemAmountWithVAT) {
          //   updateSumObject.documentTotalAmountBrutto += parseFloat(documentDet.itemAmountWithVAT) + dD1
          // }
          if (round(documentDet.itemVAT1Percentage, 2) === hrVat1) {
            updateSumObject.documentTotalVAT1Base += parseFloat(documentDet.itemBaseAmountNoVAT)
            // updateSumObject.documentTotalVAT1Amount += parseFloat(documentDet.itemVAT1Amount)
            // updateSumObject.documentTotalVAT1Base += parseFloat((documentDet.itemAmountWithVAT) - parseFloat(documentDet.itemVAT1Amount))
          }
          if (round(documentDet.itemVAT1Percentage, 2) === hrVat2) {
            updateSumObject.documentTotalVAT2Base += parseFloat(documentDet.itemBaseAmountNoVAT)
            // updateSumObject.documentTotalVAT2Amount += parseFloat(documentDet.itemVAT1Amount)
            // updateSumObject.documentTotalVAT2Base += parseFloat((documentDet.itemAmountWithVAT) - parseFloat(documentDet.itemVAT1Amount))
          }
          if (round(documentDet.itemVAT1Percentage, 2) === hrVat3) {
            updateSumObject.documentTotalVAT3Base += parseFloat(documentDet.itemBaseAmountNoVAT)
            // updateSumObject.documentTotalVAT3Amount += parseFloat(documentDet.itemVAT1Amount)
            // updateSumObject.documentTotalVAT3Base += (parseFloat(documentDet.itemAmountWithVAT) - parseFloat(documentDet.itemVAT1Amount))
          }
          if (documentDet.itemBaseAmount) {
            if (parseInt(documentDet.FreeF1) === 1) {
              updateSumObject.FreeF1 += parseFloat(documentDet.itemBaseAmount)
            }
            if (parseInt(documentDet.FreeF1) === 2) {
              updateSumObject.FreeF2 += parseFloat(documentDet.itemBaseAmount)
              updateSumObject.FreeF5 += parseFloat(documentDet.empWrkHrs)
            }
            if (parseInt(documentDet.FreeF1) === 3) {
              updateSumObject.FreeF3 += parseFloat(documentDet.itemBaseAmount)
            }
          }
          if (documentDet.itemBaseAmountNoVAT) {
            if (round(parseFloat(documentDet.itemVAT1Amount),2) === 0) {
              updateSumObject.FreeF4 += parseFloat(documentDet.itemBaseAmountNoVAT)
            }
          }
          if (documentDet.itemDirectDuty1Amount) {
            updateSumObject.documentTotalAmountDirectD1+= parseFloat(documentDet.itemDirectDuty1Amount)
          }
        })
      }

      updateSumObject.documentTotalAmountNetto = updateSumObject.documentTotalAmountNetto ? round(updateSumObject.documentTotalAmountNetto, 2) : 0
      updateSumObject.documentTotalVAT1Amount  = round((updateSumObject.documentTotalVAT1Base * ( (hrVat1/100))),2)
      updateSumObject.documentTotalVAT2Amount  = round((updateSumObject.documentTotalVAT2Base * ( (hrVat2/100))),2)
      updateSumObject.documentTotalVAT3Amount  = round((updateSumObject.documentTotalVAT3Base * ( (hrVat2/100))),2)
      updateSumObject.documentDescription9 = updateSumObject.documentDescription9 ? round(updateSumObject.documentDescription9, 2) : 0
      updateSumObject.supplierNetoAmount = updateSumObject.supplierNetoAmount ? round(updateSumObject.supplierNetoAmount, 2) : 0
      updateSumObject.supplierMargin = round(updateSumObject.documentTotalAmountNetto - updateSumObject.supplierNetoAmount, 2)
      updateSumObject.documentTotalAmountVAT = updateSumObject.documentTotalVAT1Amount + updateSumObject.documentTotalVAT2Amount + updateSumObject.documentTotalVAT3Amount
      updateSumObject.documentTotalAmountBrutto = updateSumObject.documentTotalAmountNetto + updateSumObject.documentTotalAmountVAT
      updateSumObject.documentTotalVAT1Per = hrVat1 ? round(hrVat1, 2) : 0
      updateSumObject.documentTotalVAT2Per = hrVat2 ? round(hrVat2, 2) : 0
      updateSumObject.documentTotalVAT3Per = hrVat3 ? round(hrVat3, 2) : 0

      // updateSumObject.documentTotalVAT1Base = hrVat1 && updateSumObject.documentTotalVAT1Amount ? round(updateSumObject.documentTotalVAT1Amount / (hrVat1/100), 2) : 0
      // updateSumObject.documentTotalVAT2Base = hrVat2 && updateSumObject.documentTotalVAT2Amount ? round(updateSumObject.documentTotalVAT2Amount / (hrVat2/100), 2) : 0
      // updateSumObject.documentTotalVAT3Base = hrVat3 && updateSumObject.documentTotalVAT3Amount ? round(updateSumObject.documentTotalVAT3Amount / (hrVat3/100), 2) : 0
      updateSumObject.FreeF1 = updateSumObject.FreeF1 ? round(updateSumObject.FreeF1, 2) : 0
      updateSumObject.FreeF2 = updateSumObject.FreeF2 ? round(updateSumObject.FreeF2, 2) : 0
      updateSumObject.FreeF3 = updateSumObject.FreeF3 ? round(updateSumObject.FreeF3, 2) : 0
      updateSumObject.FreeF4 = updateSumObject.FreeF4 ? round(updateSumObject.FreeF4, 2) : 0
      updateSumObject.FreeF5 = updateSumObject.FreeF5 ? round(updateSumObject.FreeF5, 2) : 0
      updateSumObject.documentDescription10 = updateSumObject.documentDescription9 - updateSumObject.documentTotalAmountNetto
      updateSumObject.documentTotalAmountPayInAdvance = updateSumObject.documentTotalAmountPayInAdvance ? round(updateSumObject.documentTotalAmountPayInAdvance, 2) : 0
      updateSumObject.documentTotalAmountToPay = updateSumObject.documentTotalAmountBrutto ? (round(updateSumObject.documentTotalAmountBrutto, 2) - (updateSumObject.documentTotalAmountPayInAdvance )): 0

      updateSumObject.documentTotalAmountNettoForeign = updateSumObject.documentTotalAmountNetto ? round((updateSumObject.documentTotalAmountNetto / this.ExRate), 2) : 0
      updateSumObject.documentTotalAmountVATForeign = updateSumObject.documentTotalAmountVAT ? round((updateSumObject.documentTotalAmountVAT / this.ExRate), 2) : 0
      updateSumObject.documentTotalAmountBruttoForeign = updateSumObject.documentTotalAmountBrutto ? round((updateSumObject.documentTotalAmountBrutto / this.ExRate), 2) : 0
      updateSumObject.documentTotalAmountPayInAdvanceForeign = round((updateSumObject.documentTotalAmountPayInAdvance  / this.ExRate), 2)
      updateSumObject.documentTotalAmountToPayForeign = updateSumObject.documentTotalAmountBrutto ? (round((updateSumObject.documentTotalAmountBrutto/ this.ExRate), 2) - (updateSumObject.documentTotalAmountPayInAdvance  / this.ExRate) ) : 0
      updateSumObject.documentTotalAmountDirectD1Fore = updateSumObject.documentTotalAmountDirectD1 ? round((updateSumObject.documentTotalAmountDirectD1 / this.ExRate), 2) : 0

      const newHead = {...this.savedDocument, ...updateSumObject}

      if (newHead) {
        await DocumentService.put(newHead)
      }
    }
  },
  computed: {
    formatDate1() {
      return this.startDate
        ? dateFormat(this.startDate)
        : "";
    },
    formatDate2() {
      return this.endDate
        ? dateFormat(this.endDate)
        : "";
    },
  },
  watch: {
    'selectGroup' () {
      console.log('Select group', this.selectGroup)
      if (!this.selectGroup) {
        this.$store.dispatch("setGroupid", null)
        delete this.documentAna.groupid
        delete this.documentAna.itemGroup
        delete this.documentAna.GroupName
        this.disableGroup = true
      }
      if (this.selectGroup && this.selectGroup.id) {
        this.$store.dispatch("setGroupid", this.selectGroup.id)
        this.documentAna.groupid = this.selectGroup.id
        this.documentAna.itemGroup = this.selectGroup.id
        this.documentAna.GroupName = this.selectGroup.GroupName
      }
      this.initData(1)
    },
    'selectedMonth' () {
     if  (this.selectedMonth) {
        let date = new Date(), y = date.getFullYear(), m = this.selectedMonth - 1;
        let firstDay = new Date(y, m, 1);
        let lastDay = new Date(y, m + 1, 0);

        this.startDate = dayjs(firstDay).format('YYYY-MM-DD')
        this.endDate = dayjs(lastDay).format('YYYY-MM-DD')
      }
      if (!this.selectedMonth) {
        this.startDate = dayjs([this.documentAna.BusinessYear]).startOf('year').format('YYYY-MM-DD')
        this.endDate = dayjs([this.documentAna.BusinessYear]).endOf('year').format('YYYY-MM-DD')
      }
    },
  },
  components: {
    DocumentWarehousestatePrint,
    DocumentItemCard,
    DocumentWarehouseGroupsPrint,
    DocumentWarehouseGroupsInOutPrint
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>


